import { ApiModelProperty } from '@nestjs/swagger/dist/decorators/api-model-property.decorator';

export class BazaDwollaInvestorAccountSyncStatusDto {
    @ApiModelProperty({
        description: 'Total count of transactions added to CMS',
    })
    countTransactions: number;

    @ApiModelProperty({
        description: 'Offerings affected by sync',
        type: 'string',
        isArray: true,
    })
    affectedOfferingIds: Array<string>;

    @ApiModelProperty({
        description: 'Is Bank Account linked?',
    })
    isBankAccountLinked: boolean;

    @ApiModelProperty({
        description: 'Is Credit Card linked?',
    })
    isCreditCardLinked: boolean;
}
